var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    [
      _c(
        "h1",
        {
          staticClass: "primary--text",
          attrs: { id: "notification-parameter" }
        },
        [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.notificationDetails)))]
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs3: "", "mb-4": "" } },
        [
          _c("v-card", {
            attrs: { flat: "", color: "greyDark", height: "1px", width: "60%" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.notifications, function(notification, index) {
        return [
          !_vm.coLoader
            ? _c(
                "h2",
                {
                  staticClass: "bold primary--text mb-2 title-anchor",
                  attrs: {
                    id: _vm.notificationAnchorId(
                      notification.section_notification_key
                    )
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(notification.section_notification_name) +
                      "\n    "
                  )
                ]
              )
            : _c("notification-title-loader"),
          _vm._v(" "),
          _c("notification-data-table", {
            key: index,
            attrs: { items: notification.section_notification_option },
            on: { "on-click-checkbox": _vm.onClickCheckbox }
          })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65ca46a7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65ca46a7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/profile-child-notification/template.html
// module id = null
// module chunks = 